export const addToStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getFromStorage = (key: string) => {
  const keyData = localStorage.getItem(key);
  if (keyData) return JSON.parse(keyData);

  return null;
};

export const removeFromStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const removeAllFromLocalStorage = () => {
  localStorage.clear();
};
